(function () {
  function initHeaderQuickQuote() {
    var root = document.querySelector('[data-raelon-header-quote-root]');
    if (!root || root.dataset.initialized === 'true') return;

    var drawer = root.querySelector('[data-raelon-header-quote-drawer]');
    var panel = root.querySelector('[data-raelon-header-quote-panel]');
    var closeButtons = root.querySelectorAll('[data-raelon-header-quote-close]');
    var form = root.querySelector('#raelon-header-quick-quote-form');
    var lastTrigger = null;

    if (!drawer || !panel) return;
    root.dataset.initialized = 'true';

    function triggers() {
      return document.querySelectorAll('[data-raelon-header-quote-trigger]');
    }

    function setTriggerState(isOpen) {
      triggers().forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    function openDrawer(trigger) {
      lastTrigger = trigger || null;
      var mobileMenu = document.getElementById('mobile-menu');
      if (mobileMenu && window.getComputedStyle(mobileMenu).display !== 'none') {
        var mobileClose = mobileMenu.querySelector('.header-mobile-menu-close');
        if (mobileClose) mobileClose.click();
      }

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('raelon-header-quick-quote-open');
      setTriggerState(true);
      window.requestAnimationFrame(function () {
        panel.focus();
      });
    }

    function closeDrawer() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('raelon-header-quick-quote-open');
      setTriggerState(false);
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-raelon-header-quote-trigger]');
      if (!trigger) return;
      event.preventDefault();
      openDrawer(trigger);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    if (form) {
      var submitButton = form.querySelector('[type="submit"]');
      var submitLabel = submitButton ? submitButton.textContent : '';
      var isSubmitting = false;
      var isSending = false;

      function getNotice() {
        var notice = form.querySelector('.raelon-header-quick-quote__notice');
        if (notice) return notice;

        notice = document.createElement('div');
        notice.className = 'raelon-header-quick-quote__notice';
        notice.hidden = true;
        form.insertBefore(notice, form.firstChild);
        return notice;
      }

      function showNotice(type, content) {
        var notice = getNotice();
        notice.className = 'raelon-header-quick-quote__notice raelon-header-quick-quote__notice--' + type;
        notice.setAttribute('role', type === 'error' ? 'alert' : 'status');
        notice.innerHTML = content;
        notice.hidden = false;
      }

      function preserveAttributionAndReset() {
        var hiddenFields = Array.prototype.map.call(
          form.querySelectorAll('input[type="hidden"][name^="contact["]'),
          function (field) {
            return { name: field.name, value: field.value };
          }
        );

        form.reset();
        form.querySelectorAll(
          '[name="form_key"], [name="h-captcha-response"], [name="g-recaptcha-response"], [name="recaptcha-v3-token"]'
        ).forEach(function (field) {
          field.remove();
        });
        hiddenFields.forEach(function (savedField) {
          var field = Array.prototype.find.call(form.elements, function (element) {
            return element.name === savedField.name;
          });
          if (field) field.value = savedField.value;
        });
      }

      function setSubmittingState() {
        var notice = getNotice();
        notice.hidden = true;
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = root.dataset.sendingText || 'Sending...';
        }
      }

      function submitAsync() {
        if (isSending) return;
        if (!isSubmitting) {
          isSubmitting = true;
          setSubmittingState();
        }
        isSending = true;

        fetch(form.action, {
          method: form.method || 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        })
          .then(function (response) {
            return response.text().then(function (html) {
              return { response: response, html: html };
            });
          })
          .then(function (result) {
            var responseDocument = new DOMParser().parseFromString(result.html, 'text/html');
            var responseUrl = new URL(result.response.url, window.location.origin);
            var responseError = responseDocument.querySelector(
              '#raelon-header-quick-quote-form .raelon-header-quick-quote__notice--error, ' +
              '.raelon-header-quick-quote__notice--error'
            );
            var accepted = responseUrl.searchParams.get('contact_posted') === 'true' ||
              Boolean(responseDocument.querySelector('.raelon-header-quick-quote__notice--success'));

            if (accepted) {
              preserveAttributionAndReset();
              showNotice(
                'success',
                root.dataset.successHtml || '<strong>Request Sent Successfully</strong><br>Thanks! We received your request and our team will get back to you soon.'
              );
              return;
            }

            if (responseError) {
              showNotice('error', responseError.innerHTML);
              return;
            }

            throw new Error('Shopify did not confirm the contact request.');
          })
          .catch(function () {
            showNotice('error', root.dataset.errorText || 'We could not send your request. Please review your information and try again.');
          })
          .finally(function () {
            isSending = false;
            isSubmitting = false;
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = submitLabel;
            }
          });
      }

      form.submit = submitAsync;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (isSubmitting) return;

        isSubmitting = true;
        setSubmittingState();

        if (form.dataset.hcaptchaBound !== 'true') {
          window.setTimeout(function () {
            if (
              isSubmitting &&
              !isSending &&
              form.dataset.hcaptchaBound === 'true' &&
              typeof form.requestSubmit === 'function'
            ) {
              form.requestSubmit();
            }
          }, 1000);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderQuickQuote);
  } else {
    initHeaderQuickQuote();
  }

  document.addEventListener('shopify:section:load', initHeaderQuickQuote);
})();
